import { AspectRatio, ContainerVm } from 'qp-ui-interface';
import { BaseCardWidth, CarouselSize, CarouselStyle, CarouselType } from '../shared-components/cards-carousel/model/cards-carousel-models';

export const getCarouselType = (container: ContainerVm): CarouselType => {
  const { style, size, resources, sourceType } = container;
  if (sourceType === CarouselStyle.ON_GOING) {
    return CarouselType.ON_GOING;
  } else if (style === CarouselStyle.ROUNDED) {
    return CarouselType.SMALL_CIRCLE;
  } else if (resources && resources[0]?.type === 'collection' && container?.aspectRatio?.includes('1x1')) {
    return CarouselType.SQUARE_SMALL;
  } else if (
    // if container is a continue watching container it will be regular and regular
    (style === CarouselStyle.REGULAR && size === CarouselSize.REGULAR) ||
    container.id.toLocaleLowerCase() === 'cvm-ContinueWatching' ||
    container?.sourceType?.includes('continue_watching')
  ) {
    return CarouselType.SQUARE_REGULAR;
  } else if (style === CarouselStyle.REGULAR && size === CarouselSize.LARGE) {
    return CarouselType.SQUARE_LARGE;
  } else if (sourceType === CarouselStyle.PLAYER_EPISODES) {
    return CarouselType.SQUARE_REGULAR_WITH_DESCRIPTION;
  } else {
    return CarouselType.SQUARE_REGULAR;
  }
};

export const getCarouselImageWidth = (carouselType: CarouselType, aspectRatio?: AspectRatio): number => {
  let baseWidth: number = BaseCardWidth[carouselType];
  // If the aspect ratio is 16x9 and the carouselType is SQUARE_REGULAR, set base width to 390
  if (carouselType === CarouselType.SQUARE_REGULAR && aspectRatio === '16x9') {
    baseWidth = BaseCardWidth[CarouselType.SQUARE_LARGE];
  }
  // If the aspect ratio is 16x9 and the carouselType is SQUARE_LARGE, set base width to 600
  else if (carouselType === CarouselType.SQUARE_LARGE && aspectRatio === '16x9') {
    baseWidth = BaseCardWidth[CarouselType.ON_GOING];
  }

  // Compute width based on screen size using a rule of three
  const screenWidth = window.innerWidth;
  const imageNeededWidth = (baseWidth * screenWidth) / 1920;
  // Round to the nearest 50
  return Math.round(imageNeededWidth / 50) * 50;
};

export const getShowPlayIcon = (container: ContainerVm): boolean => {
  // Play icon should be shown only for continue watching container
  return getShowProgress(container);
};

export const getShowProgress = (container: ContainerVm): boolean => {
  if (container) {
    const { id, sourceType } = container;
    if (
      id.toLocaleLowerCase() === 'cvm-continuewatching' ||
      sourceType?.includes('continue_watching') ||
      id === 'cvm-player-morelikethis'
    ) {
      return true;
    }
  }
  return false;
};

export const showHeroByUrl = (url: string) => {
  return (
    !url.includes('/myhub') &&
    !url.includes('/search') &&
    !url.includes('/genres') &&
    !url.includes('/artist') &&
    !url.includes('/view-all')
  );
};

export const getCollectionPages = (aspectRatio: AspectRatio) => {
  switch (aspectRatio) {
    case '16x9':
    case '1x1':
    case '4x3':
    case '5x1':
      return 2;
    case '2x3':
      return 1;
    default:
      return 1;
  }
};

/**
 * Check if the aspect ratio is supported
 *
 * @param aspectRatio
 * @returns
 */
export const checkAspectRatio = (aspectRatio: string) => {
  switch (aspectRatio) {
    // as per UV BRD
    case '16x9':
    case '1x1':
    case '2x3':
    // default qp support
    case '4x3':
    case '5x1':
      return aspectRatio;
    default:
      return null;
  }
};
